import { AppRoleSummary } from '~/models/administration/approle';

export class FormTabAuthorizations{
   id: number;
   appRole: AppRoleSummary;
   canView: boolean;
   canEdit: boolean;
   defaultCanView: boolean;
   defaultCanEdit: boolean;


   constructor(){
     this.appRole = new AppRoleSummary();
     this.canView = false;
     this.canEdit = false;
     this.defaultCanView = false;
     this.defaultCanEdit = false;
   }
}
